export default __webpack_public_path__ + "static/media/xray.76c94f8c.svg";